import React from "react"
import Card from "../core/Card"
import { Icon } from "antd"
import styled from "styled-components"
class HubspotForm extends React.Component {
  componentDidMount() {
    const script = document.createElement("script")
    script.src = "https://js.hsforms.net/forms/v2.js"
    document.body.appendChild(script)

    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "4659865",
          formId: "7e808689-3b1b-4acc-946e-ed3b8e38fab3",
          target: "#hubspotForm",
          cssClass: "hubspotForm"
        })
      }
    })
  }

  render() {
    return (
      <div>
        <div id="hubspotForm" />
      </div>
    )
  }
}

const CenteredDiv = styled.div`
  padding: 0 10vw;
  a {
    color: #3b88b6;
  }
`

const SellingPoints = styled.ul`
  li {
    padding: 20px 0;
  }
  b {
    color: #3b88b6;
    display: block;
    font-size: 18px;
  }
  padding-bottom: 30px;
`

const TeamsFeatures = () => (
  <div>
    <Card>
      <h1>Teams</h1>
      <CenteredDiv>
        <SellingPoints>
          <li>
            <b>Improve productivity</b>
            Significant time savings for employees and the back office.
          </li>
          <li>
            <b>Reimburse according to GPS data</b>
            Rest easy knowing everything is backed up to the cloud in case of an
            audit.
          </li>
          <li>
            <b>Remove frustration</b>
            Employees should be doing the job they love, not filling out expense
            reports!
          </li>
        </SellingPoints>
        <h3>We'd love to learn if Teams is a good fit for you</h3>
        <HubspotForm />
        <p>
          See our features at{" "}
          <a target="_blank" href="https://everlance.com/teams">
            everlance.com/teams
          </a>
        </p>
      </CenteredDiv>
    </Card>
  </div>
)

export default TeamsFeatures



// WEBPACK FOOTER //
// ./src/enterprise/TeamsFeatures.js